import React from "react";
import {Button as MTLButton, Stack, TextField, FormControl, InputLabel, Select, MenuItem, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import {Button} from "../../components/FormZero/Button/Button";
import axios from "axios";
import {Autocomplete} from "@mui/material";
import {
    convertDateToBallCalendar
} from "../../components/FormZero/PageComponents/FormPane/SubComponents/Form_WeekSelection";
import { Form_Button } from "../../components/FormZero/PageComponents/FormPane/SubComponents";

export{}
declare global {
    interface Array<T> {
        last(elem: T): Array<T>;
    }
}

if (!Array.prototype.last){
    Array.prototype.last = function(){
        return this[this.length - 1];
    };
}

/*

    const [filteredRoutes, setFilteredRoutes] = React.useState(routeList );
    React.useEffect(() => {
        if (routeList !== undefined){
            // routeList
            setFilteredRoutes(routeList);

            // this is likely to be used later on.
            // let c = routeList.filter((route) => {
            //     if (route === undefined || route.locations === undefined || route.locations === null || route.locations.length === 0){
            //         return false;
            //     }
            //     let locations = route.locations.filter((loc) => {
            //         // alert(JSON.stringify(loc));
            //         let res = (
            //             loc.CustomerName === cellValues.row.ShipToName &&
            //             loc.City === cellValues.row.ShipToCity &&
            //             loc.State === cellValues.row.ShipToState
            //         )
            //         // console.log(loc);
            //         // console.log(cellValues.row);
            //         // console.log(res)
            //         return res;
            //     });
            //     return locations.length > 0;
            // });
            // // console.log(c);
            // setFilteredRoutes(c);

            // TODO: for each route if it doesn't have a load assigned create a load for the selected week.

        }
        else {
            setFilteredRoutes([]);
        }

    }, [routeList])


 */

export function RouteDialog(props : any) {
    const {
        cellValues,
        currentLoad,
        currentRoute,
        routes,
        updateView,
        routeOnly = false,
        onOpen,
        onClose
    } = props;

    const [open, setOpen] = React.useState(false);
    React.useEffect(() => {
        if (open){
            if (onOpen !== undefined) onOpen();
        } else {
            if (onClose !== undefined) onClose();
        }
    }, [open]);
    const [route, setRoute] = React.useState(currentLoad);
    React.useEffect(() => { setRoute(currentRoute) }, [currentRoute])
    const [routeList, setRouteList] = React.useState(routes);
    React.useEffect(() => { setRouteList(routes) }, [routes])
    const [load, setLoad] = React.useState(currentLoad);
    React.useEffect(() => { setLoad(currentLoad) }, [currentLoad])
    // const [loadList, setLoadList] = React.useState([]);


    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const saveDelivery = async function(delivery_id : any) {
        try {
            // const result
            if (value === undefined || value === null) {
                return;
            }
            let route = value.id;
            let loadInfo = JSON.parse(JSON.stringify(load));
            if (routeOnly) {
                let list = routeFilter(routeList, route).loads.filter((load : any) => {
                    return load.Shipped !== 1 && load.week_number === cellValues.row['week_number'] && load.year === cellValues.row['year']
                });
                if (list.length > 0){
                    console.info(list[0]);
                    console.log(list[0]);
                    loadInfo = list[0].id;
                }
                else {
                    const response = await axios.post(`logistic/loads/${route}`, { week_number: cellValues.row['week_number'], year: cellValues.row['year'] });
                    console.log(response.data[4]);
                    loadInfo = response.data[4].id;
                }
            }

            // alert(loadInfo);
            await axios.put(`logistic/delivery/${delivery_id}`, {
                // logistics_loads_id: loadInfo
                field: "logistics_loads_id",
                value: loadInfo
            });
            if (updateView !== undefined) {
                updateView()
            }
            setOpen(false);
        }
        catch (e) {
            console.log(e);
            // setResult(e);
        }
    };
    const handleSaveAndClose = () => {
        saveDelivery(cellValues.row.id).then(() => {});
    };

    const handleChange = (event: { target: { value: any; }; }) => {
        setRoute(event.target.value);
    };

    const handleLoadChange = (event: { target: { value: any; }; }) => {
        setLoad(event.target.value);
    };

    const routeFilter = (list: any[], route: any) => {
        return list.filter((r: { id: any; }) => r.id === route)[0];
    };

    const [loads, setLoads] = React.useState<any>([]);
    const [value, setValue] = React.useState<any>("");
    const [inputValue, setInputValue] = React.useState<any>('');

    React.useEffect(() => {
        if (routeList === undefined){
            return;
        }
        if (routeList.filter((r: { id: any; }) => r.id === value.id).length === 1){
            setLoads(routeList.filter((r: { id: any; }) => r.id === value.id)[0].loads);
        }
        else {
            setLoads([]);
        }
    }, [value, routeList])

    const createNewLoad = async function() {
        try { 
            const r = await axios.post(`${process.env.REACT_APP_ENDPOINT}/api/Loads/${value.id}`, { weekNumber: cellValues.row['week_number'], year: cellValues.row['year'] });
            console.log(r.data);
            // const response = await axios.get(`/logistic/routes/week/${cellValues.row['week_number']}/${cellValues.row['year']}`);
            // setRouteList(response.data);
            // alert("line 168")

            if (updateView !== undefined) {
                // alert(171)
                await updateView()
                setLoad(routeList.filter((r: { id: any; }) => r.id === value.id)[0].loads.last().id)
                // alert(173);
            }
        }
        catch (e) {
            console.log(e);
            alert(e)
            // setResult(e);
        }
    };

    const [hasCost, setHasCost] = React.useState(false);
    const checkIfLocationHasCost = async function() {
        const customers = (await axios.get("logistic/customers")).data;

        let locations = customers.filter((loc: { CustomerName: any; City: any; State: any; }) => {
            // alert(JSON.stringify(loc));
            return (
                loc.CustomerName === cellValues.row.ShipToName &&
                loc.City === cellValues.row.ShipToCity &&
                loc.State === cellValues.row.ShipToState
            );
        });

        console.log(locations);

        return locations[0].tray_freight_cost !== undefined && locations[0].tray_freight_cost !== null;
    };
    React.useEffect(() => {
        checkIfLocationHasCost().then((r) => setHasCost(r));
    }, [cellValues.row]);



    return (<>

        <MTLButton
            variant="contained"
            color="primary"
            fullWidth={true}
            disabled={!hasCost}
            onClick={(event) => {
                event.stopPropagation();
                handleClickOpen();
            }}
        >Change Route</MTLButton>
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Change Route</DialogTitle>
            <DialogContent style={{width: "300px"}}>
                <p>Delivery: {cellValues.row['BrokerDeliveryID']}</p>
                {/*<pre>{JSON.stringify(inputValue)}</pre>*/}
                <pre>{JSON.stringify(cellValues.row['week_number'])}</pre>
                {/*<pre>{JSON.stringify(loads)}</pre>*/}
                {/*<pre>{JSON.stringify(routeList[route])}</pre>*/}
                {/*<pre>{JSON.stringify(routeList, undefined, 4)}</pre>*/}
                <Autocomplete
                    options={routeList.map((d: { RouteName: any; id: any; }) => {
                        return {
                            label : d.RouteName,
                            id: d.id
                        }
                    }) || []}
                    value={value}
                    onChange={(event, newValue) => {
                        setValue(newValue);
                    }}
                    inputValue={inputValue}
                    onInputChange={(event, newInputValue) => {
                        setInputValue(newInputValue);
                    }}
                    fullWidth={true}
                    renderInput={(params) => {
                        return (<TextField  {...params} label="Route"/>);
                    }}
                />
                {(routeOnly !== true) && (
                    <div style={{display:'flex', marginTop:'0.5rem', gap: '0.5rem'}}>
                        <FormControl fullWidth sx={{m: 1, minWidth: 120}}>
                            <InputLabel id="demo-simple-select-label">Load</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={load}
                                label="Load"
                                onChange={handleLoadChange}
                                MenuProps={{
                                    anchorOrigin: {
                                        vertical: "bottom",
                                        horizontal: "left"
                                    },
                                    transformOrigin: {
                                        vertical: "top",
                                        horizontal: "left"
                                    },
                                }}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {loads.map((x: { id: any; LoadNumber: any; }) => (<MenuItem key={x.id} value={x.id}>{x.LoadNumber}</MenuItem>))}
                                {/*{routeList[route].loads}*/}
                                {/*{(route !== undefined && routeFilter(routeList, route) !== undefined) && (*/}
                                {/*    routeFilter(routeList, route).loads.map((x) => (<MenuItem key={x.id} value={x.id}>{x.LoadNumber}</MenuItem>))*/}
                                {/*)}*/}
                            </Select>
                        </FormControl>
                        <Form_Button
                            disabled={value === ""}
                            // disabled={true}
                            variant="contained"
                            color="primary"
                            onClick={(event : any) => {
                                event.stopPropagation();
                                // handleClickOpen();
                                createNewLoad().then();
                                // TODO: create new route here.
                            }}
                        >Add</Form_Button>
                    </div>
                )}
            </DialogContent>
            <DialogActions>
                <Stack direction="row" spacing={2}>
                    <Button onClick={handleClose} text={"Cancel"}/>
                    <Button onClick={handleSaveAndClose} text={"Save"} color={"secondary"}/>
                </Stack>
            </DialogActions>
        </Dialog>
    </>);
}